<div class="sec-title">
    <h1>Bons de Commande</h1>
</div>
  <ul class="editing-list list-group">
    <li class="list-group-item list-group-header">
      <div class="card">
        <div class="row">
          <div class="col-lg-8 col-md-12">
          </div>
          <div class="col-lg-1 col-md-4 mt-4">
            <a class="btn btn-action btn-filter me-3  mb-3" [ngClass]="{'selected_filter': filter=='all'}" (click)="changeFilter('all')" role="button"> Tous</a>
          </div>
          <div class="col-lg-3 col-md-12 align-text-bottom header-action-btn">

            <form [formGroup]="searchOrderForm" (ngSubmit)="onSubmit(searchOrderForm.value)" novalidate>
              <div class="form-group input-group mb-3">
                <label for="search_order" class="visually-hidden">Recherche</label>
                <input type="text" class="form-control" name="search_order" id="search_order" formControlName="search_order" placeholder="Recherche...">
                <div class="input-group-append">
                  <button type="submit" class="input-group-text right-action-btn">
                    <i title="Recherche" class="bi bi-search"></i>
                  </button>
                </div>
              </div>
  
              <button type="submit" class="btn btn-primary visually-hidden">Rechercher</button>
            </form>

         </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-6 col-md-11">
                  <div class="row">
                    <div class="col-md-6 col-lg-1">Comm #</div>
                    <div class="col-md-6 col-lg-2">Date</div>
                    <div class="col-md-6 col-lg-2">Contrat</div>
                    <div class="col-md-6 col-lg-3">Client</div>
                    <div class="col-md-6 col-lg-3">Adresse</div>
                  </div>
                </div>
                <div class="col-md-1 d-flex justify-content-end action-icons">
                  <div>Modifier</div>
                </div>
            </div>
        </div>
      </div>
    </li>
    <li class="list-group-item" *ngIf="total === 0 && isSearch == true">
      <div class="card">
        <div class="card-body">
          <div class="row mt-3 ms-3 mb-3 strong">
                {{no_results_message}}
          </div>
        </div>
      </div>
    </li>
    <li *ngIf="diplay_loading != '' && isSearch == false; else Results" class="list-group-item">
      <div class="card">
        <div class="card-body">  
          <div class="mt-3 ms-3 mb-3 strong">
            {{ diplay_loading }} 
            <span class="spinner-grow spinner-grow-sm ms-2" style="width: 0.5rem; height: 0.5rem;" role="status" aria-hidden="true"></span>
            <span class="spinner-grow spinner-grow-sm ms-2" style="width: 0.5rem; height: 0.5rem;" role="status" aria-hidden="true"></span>
            <span class="spinner-grow spinner-grow-sm ms-2" style="width: 0.5rem; height: 0.5rem;" role="status" aria-hidden="true"></span>
          </div>
        </div>
      </div>
    </li>
    <ng-template #Results>
      <li class="list-group-item" *ngFor="let order of orderInfo | paginate: { itemsPerPage: limits, currentPage: p+1, totalItems: total}; let i = index">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-11">
                <div class="row"  *ngIf="total === 0">
                  {{no_results_message}}
                </div>
                <div class="row">
                  <div class="col-md-1">
                    <p class="card-title">#{{order.order_no}}</p>
                  </div>
                  <div class="col-md-2">
                    <p class="card-title card-title-main">{{order.created | date}}</p>
                  </div>
                  <div class="col-md-2">
                    <p class="card-title card-title-main"> <a href="/soumission/{{order.submission.submission_id}}/editer"><i class="bi bi-link"></i>{{order.submission.submission_no}} </a></p>
                  </div>
                  <div class="col-md-3">
                    <p class="card-title card-title-main"><a href="/client/{{order.submission.client_id}}/editer"><i class="bi bi bi-person"></i>{{order.submission.client_first_name}} {{order.submission.client_last_name}}</a></p>
                  </div>
                  <div class="col-md-3">
                    <div class="card-subtitle mb-2 text-muted">
                      <address> 
                        {{order.submission.address}}, {{order.submission.city}}, 
                        {{order.submission.province}} {{order.submission.address2}} 
                        {{order.submission.country}}
                      </address>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-1 d-flex justify-content-end action-icons">

                <a routerLink="/soumission/{{order.submission_id}}/editer" class="card-link">
                  <button type="button" class="btn btn-outline-secondary left-action-btn">
                    <i class="bi bi-card-list" title="Voir le contrat"></i>
                  </button>
                </a>
                <a (click)="orderPrint(order.order_id)" class="card-link">
                  <button type="button" class="btn btn-outline-secondary middle-action-btn">
                    <i class="bi bi-printer-fill"  title="imprimer"></i>
                  </button>
                </a>
                <a routerLink="/commande/{{order.order_id}}/editer" class="card-link">
                  <button type="button" class="btn btn-outline-secondary right-action-btn">
                    <i class="bi bi-pencil-square"  title="Modifier le bon de commande"></i>
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ng-template>
  </ul>
  <pagination-controls (pageChange)="pageChangeEvent($event)"></pagination-controls>
  <hr/>
  <div id="print-section"></div>